import { Box, Text, Fade, Stack, useDisclosure } from "@chakra-ui/react";
import BaseLayout from "../../components/base_layout";
import MypageNavigation from "../../components/navi/mypageNavi";
import React, { useState, useEffect, useCallback } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useRouter } from "next/router";
import { getReferrer } from "../../provider/referrer";
import { GetCookie } from "../../provider/common";
import { getEstimateData } from "../api/estimate";
import Pagination from "react-js-pagination";
import Link from "next/link";

const axios = require("axios").default;
export default function EsimateRequest() {
  const router = useRouter();
  const [isLogin, setIsLogin] = useState(0);
  const [referrer, setReferrer] = useState("");
  useEffect(() => {
    checkLogin();
    setReferrer(getReferrer());
  }, []);

  // 로그인 체크
  const checkLogin = async () => {
    const loginInfo = await GetCookie("isLogin");
    setIsLogin(loginInfo);
  };

  return (
    <BaseLayout>
      <Box className="mypage">
        <Box className="mypage_menu">
          <ul>
            <li className="active">
              <Link href="/estimate/fast">견적신청</Link>
            </li>
            <li>
              <Link href="/estimate/fast_lists">견적내역</Link>
            </li>
          </ul>
        </Box>
        <Box className="mypage_content quote_content">
          <div className="center-body quote_center_body">
            {/* <h1 style={{ marginBottom: "150px" }}>{title}</h1> */}
            <Box className="quote_body">
              <div className="quote_body_register_img">
                <img
                  src="../../images/banner_select_03.png"
                  width="100%"
                  height="auto"
                />
              </div>
              <div className="quote_body_register_ex">
                <div>
                  <p>
                    <span>판다봇 견적</span>
                    <span>제조사 2,900개+, 부품 1,500만개+ 부품을</span>
                    <span>단 1분이내 실시간 자동 견적비교</span>
                    <span>
                      글로벌 유통사 실시간 가격으로 최적의 부품을 찾아드립니다.
                    </span>
                  </p>
                </div>
              </div>
              <div>
                <span>견적유형을 선택해주세요</span>
                <Box className="quote_body_btn">
                  <a
                    href={
                      isLogin === "1"
                        ? "/estimate/fast_request"
                        : "/auth/login?before=/estimate/fast_request"
                    }
                  >
                    일반 견적요청
                  </a>
                  <a
                    href={
                      isLogin === "1"
                        ? "/estimate/fast_request_file"
                        : "/auth/login?before=/estimate/fast_request_file"
                    }
                  >
                    BOM 견적요청
                  </a>
                </Box>
              </div>
            </Box>
          </div>
        </Box>
      </Box>
    </BaseLayout>
  );
}
